import { Button, Input } from '@/design-system'
import { useRouter } from 'next/router'
import React, { useCallback, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { setCookies } from 'cookies-next'

const SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITEKEY

const TIMEOUT = 30

export default function VerifyForm({ verificationId, verifyDoneCallback }) {
  const [count, setCount] = useState()
  const [submitting, setSubmitting] = useState(false)

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm()

  // const waitForSms = () => {
  //   let counter = TIMEOUT

  //   const interval = setInterval(() => {
  //     counter--
  //     setCount(counter)
  //     if (counter == 0) {
  //       clearInterval(interval)
  //     }
  //   }, 1000)

  //   return interval
  // }

  // const resend = async () => {
  //   waitForSms()
  //   fetch(`/api/auth/resend/${verificationId}`)
  // }

  // useEffect(() => {
  //   const interval = waitForSms()

  //   return () => clearInterval(interval)
  // }, [])

  const onSubmit = async (formData) => {
    setSubmitting(true)
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(SITE_KEY, { action: 'submit' })
        .then(async (token) => {
          formData['recaptchaResponse'] = token
          formData['id'] = verificationId

          const verifyRes = await fetch('/api/auth/verify', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          })

          const verifyJson = await verifyRes.json()
          if (verifyJson.error) {
            setSubmitting(false)
            setError('verification_code', {
              type: 'custom',
              message: verifyJson.error,
            })
          } else {
            let expiryDate = new Date()
            expiryDate = new Date(
              expiryDate.getTime() + 60 * 60 * 24 * 30 * 1000
            ) // ~one month
            setCookies('pmt_session', verifyJson.pmt_session, {
              secure: process.env.NODE_ENV != 'development',
              sameSite: 'lax',
              expires: expiryDate,
            })

            verifyDoneCallback && verifyDoneCallback(verifyJson.pmt_session)
          }
        })
        .catch((error) => {
          console.log('error', error.message)
        })
    })
  }

  return (
    <>
      <div className="mb-16 lg:px-0">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="py-4">
            <div className="mb-8 text-lg sm:px-0 max-w-lg">
              Am trimis un cod SMS de verificare din 6 cifre către numărul tău
              de telefon. Ar trebui să ajungă în maxim 30 de secunde.
            </div>
            <div className="px-4 py-5 mb-4 border-t-0 md:border-l-4 bg-primary-bg border-primary sm:p-6">
              <div>
                <Input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  autoComplete="one-time-code"
                  autoFocus
                  label="Codul primit"
                  className="max-w-[12ch]"
                  error={errors.verification_code}
                  {...register('verification_code', {
                    validate: (v) => {
                      if (v.length < 6) return 'Cod incomplet'
                    },
                  })}
                />
                <div className="hidden col-span-6 sm:block"></div>
              </div>
            </div>
            <div className="pt-2 sm:mx-0">
              <Button
                primary
                disabled={submitting}
                fullWidth
                className="flex items-center justify-center"
              >
                {submitting && (
                  <svg
                    className="w-5 h-5 mr-2 text-white animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx={12}
                      cy={12}
                      r={10}
                      stroke="currentColor"
                      strokeWidth={4}
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                  </svg>
                )}
                Intră în cont
              </Button>
              {/* <span>sau</span>
                {count > 0 ? (
                  <Button disabled className="inline-block no-underline">
                    Retrimite codul prin SMS (în {count} secunde)
                  </Button>
                ) : (
                  <Button
                    onClick={(e) => {
                      e.preventDefault()
                      setCount(TIMEOUT)
                      resend()
                    }}
                  >
                    Retrimite codul prin SMS
                  </Button>
                )} */}
            </div>
          </div>
        </form>
      </div>
    </>
  )
}
